export function formatPhoneLocal(phone: string | undefined | null, countryPrefix: string): string {
  if (!phone || !countryPrefix) return phone || '';
  if (phone.startsWith(countryPrefix)) {
    return '0' + phone.slice(countryPrefix.length);
  }
  return phone;
}
